import React from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../app/store';
import { updateCaseManage } from '../../../../services/CaseManagementService';
import { useGetMyProfileQuery } from '../../../../services/ProfileService';

const CodingReviewActions: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentCase } = useAppSelector(state => state.caseManage);
  const { data: currentUserProfile } = useGetMyProfileQuery();

  const handleCodingAction = (action: 'Approved' | 'Denied' | 'Pending') => {
    const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
    const currentUser = currentUserProfile?.name || currentUserProfile?.identity || 'Unknown User';
    
    dispatch(updateCaseManage({ 
      codingReviewStatus: action,
      codingReviewBy: currentUser,
      codingReviewDate: currentDate
    }));
  };

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>Review Actions</Typography>
      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          size="small"
          onClick={() => handleCodingAction('Approved')}
          sx={{ 
            backgroundColor: '#10b981',
            '&:hover': { backgroundColor: '#059669' },
            textTransform: 'none',
            color: 'white'
          }}
        >
          Approve
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => handleCodingAction('Denied')}
          sx={{ 
            backgroundColor: '#f87171',
            '&:hover': { backgroundColor: '#ef4444' },
            textTransform: 'none',
            color: 'white'
          }}
        >
          Deny
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => handleCodingAction('Pending')}
          sx={{ 
            backgroundColor: '#fbbf24',
            '&:hover': { backgroundColor: '#f59e0b' },
            textTransform: 'none',
            color: 'white'
          }}
        >
          Pend
        </Button>
      </Stack>
    </Box>
  );
};

export default CodingReviewActions;
